export default __webpack_public_path__ + "static/media/product30.25bf0a34.png";